module.exports = __webpack_public_path__ + "img/5.c825bd34.jpg";